import React, { useContext } from 'react';
import { AuthContext } from '../../context/AuthContext';

const MessageBubble = ({ message, isOwn, onAcceptDuel, onDeclineDuel }) => {
    const { user: currentUser } = useContext(AuthContext);

    const isDuelInvite = message.message_type === 'DUEL_INVITE' || (message.content && message.content.includes('Plant Duel'));
    const isDuelResult = message.message_type === 'DUEL_RESULT';
    const gameId = message.related_duel_id || message.metadata?.duel_id || message.metadata?.game_id;
    const realIsOwn = currentUser
        ? (message.sender === currentUser.id || message.sender === currentUser.username)
        : isOwn;
    const time = new Date(message.timestamp).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });

    if (isDuelInvite) {
        return (
            <div className={`flex ${isOwn ? 'justify-end' : 'justify-start'} mb-2`}>
                <div className={`max-w-[80%] rounded-2xl overflow-hidden border shadow-md ${
                    isOwn
                        ? 'bg-gradient-to-br from-plantlix-500/10 to-plantlix-700/10 border-plantlix-500/20 rounded-br-sm'
                        : 'bg-white dark:bg-[#1e1e1e] border-gray-100 dark:border-white/10 rounded-bl-sm'
                }`}>
                    <div className="p-4">
                        <div className="flex items-center gap-3 mb-3">
                            <div className="w-10 h-10 rounded-xl bg-amber-100 dark:bg-amber-900/30 flex items-center justify-center flex-shrink-0">
                                <span className="text-xl">⚔️</span>
                            </div>
                            <div>
                                <p className="font-black text-xs uppercase tracking-wider text-amber-600 dark:text-amber-400">Pflanzen-Duell</p>
                                <p className="text-[11px] text-gray-500 dark:text-gray-400">Herausforderung</p>
                            </div>
                        </div>
                        <p className="text-sm text-gray-700 dark:text-gray-200 leading-relaxed mb-4">{message.content}</p>
                        {realIsOwn ? (
                            <div className="flex items-center gap-2 text-xs text-gray-400 bg-gray-50 dark:bg-white/5 rounded-xl px-3 py-2">
                                <div className="w-3 h-3 rounded-full border-2 border-current border-t-transparent animate-spin" />
                                Warte auf Antwort...
                            </div>
                        ) : (
                            <div className="grid grid-cols-2 gap-2">
                                <button
                                    onClick={() => onAcceptDuel(gameId)}
                                    disabled={!gameId}
                                    className="py-2.5 bg-plantlix-500 hover:bg-plantlix-600 text-white rounded-xl text-xs font-bold uppercase tracking-wide transition-all disabled:opacity-50"
                                >
                                    Annehmen ✓
                                </button>
                                <button
                                    onClick={() => onDeclineDuel(gameId)}
                                    disabled={!gameId}
                                    className="py-2.5 bg-red-50 dark:bg-red-900/20 hover:bg-red-100 text-red-600 dark:text-red-400 border border-red-200 dark:border-red-800 rounded-xl text-xs font-bold uppercase tracking-wide transition-all disabled:opacity-50"
                                >
                                    Ablehnen ✗
                                </button>
                            </div>
                        )}
                    </div>
                    <div className={`px-4 pb-2 text-[10px] flex justify-end gap-1 ${isOwn ? 'text-plantlix-500/60' : 'text-gray-400'}`}>
                        <span>{time}</span>
                        {isOwn && <span>{message.is_read ? '✓✓' : '✓'}</span>}
                    </div>
                </div>
            </div>
        );
    }

    if (isDuelResult) {
        return (
            <div className={`flex ${isOwn ? 'justify-end' : 'justify-start'} mb-2`}>
                <div className="max-w-[80%] rounded-2xl overflow-hidden bg-gradient-to-br from-amber-50 to-yellow-50 dark:from-amber-900/20 dark:to-yellow-900/10 border border-amber-200 dark:border-amber-800/40 shadow-md">
                    <div className="p-4">
                        <div className="flex items-center gap-2 mb-2 text-amber-600 dark:text-amber-400 font-black text-xs uppercase tracking-wider">
                            <span>🏆</span> <span>Duell-Ergebnis</span>
                        </div>
                        <p className="text-sm text-gray-700 dark:text-gray-200 whitespace-pre-wrap leading-relaxed">{message.content}</p>
                    </div>
                    <div className="px-4 pb-2 text-[10px] flex justify-end text-amber-600/60">
                        <span>{time}</span>
                    </div>
                </div>
            </div>
        );
    }

    return (
        <div className={`flex ${isOwn ? 'justify-end' : 'justify-start'} mb-1`}>
            <div className={`max-w-[75%] rounded-2xl px-4 py-2.5 shadow-sm ${
                isOwn
                    ? 'bg-plantlix-500 text-white rounded-br-sm'
                    : 'bg-white dark:bg-[#1e1e1e] text-gray-800 dark:text-gray-100 border border-gray-100 dark:border-white/[0.07] rounded-bl-sm'
            }`}>
                <p className="text-sm leading-relaxed whitespace-pre-wrap break-words">{message.content}</p>
                <div className={`flex items-center justify-end gap-1 mt-1 text-[10px] ${
                    isOwn ? 'text-plantlix-100/70' : 'text-gray-400'
                }`}>
                    <span>{time}</span>
                    {isOwn && (
                        <span className={message.is_read ? 'text-plantlix-100' : 'text-plantlix-100/50'}>
                            {message.is_read ? '✓✓' : '✓'}
                        </span>
                    )}
                </div>
            </div>
        </div>
    );
};

export default MessageBubble;
